/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BowlSpeed { 
    production_min?: number;
    production_mean?: number;
    production_max?: number;
    cip_min?: number;
    cip_mean?: number;
    cip_max?: number;
}

